export default __webpack_public_path__ + "static/media/070_boost.last.95ff054e.avif";